import { useCallback } from 'react';

const useSearchExecutor = ({
   isFromPaidJob = false,
   isFromCrawler = false,
   searchedKeyword = null,
   searchedLocation = null,
   narrowSearchParamsViewModel,
}) => {
    const executeSearch = useCallback(async ({
        keywordSearch,
        locationSearch,
        locationSuggest,
        searchParams
    }) => {
        try {
            const cleanKeyword = keywordSearch?.replaceAll('/', ' ') || '';
            const cleanLocation = locationSearch?.replaceAll('/', ' ') || '';
            // 入力値が空ならサジェストが残っていても無視する
            const suggestValue = cleanLocation === '' ? '' : (locationSuggest || '');

            const apiUrl = new URL(generateUrlApiPath, window.location.origin);
            apiUrl.searchParams.append('keyword', cleanKeyword);
            apiUrl.searchParams.append('location', cleanLocation);
            apiUrl.searchParams.append('locationSuggest', suggestValue);

            const response = await fetch(apiUrl.toString());
            if (!response.ok) {
                throw new Error('Failed to fetch search URL');
            }

            const result = await response.json();
            let searchUrl = result.url;

            // Distance絞り込みが無効な場合、そのパラメータを削除
            if (!result.isFilterableByDistance) {
                searchParams.delete(narrowSearchParamsViewModel.distanceParamKey);
            }

            let finalUrl = searchUrl;
            const queryString = searchParams.toString();
            if (queryString) {
                finalUrl = `${searchUrl}?${queryString}`;
            }

            // 送客課金ページかつキーワード・勤務地の検索条件が同じであれば、遷移先も送客課金ページにする
            const isPaidJobCondition = (
                isFromPaidJob &&
                searchedKeyword === cleanKeyword &&
                searchedLocation === cleanLocation
            );

            if (isPaidJobCondition) {
                const separator = finalUrl.includes('?') ? '&' : '?';
                finalUrl = `${finalUrl}${separator}type=pft`;
            }
            // クローラーアクセスページかつキーワード・勤務地の検索条件が同じであれば、遷移先もクローラーアクセスページにする
            const isCrawlerAccessCondition = (
                isFromCrawler &&
                searchedKeyword === cleanKeyword &&
                searchedLocation === cleanLocation
            );

            if (isCrawlerAccessCondition) {
                const separator = finalUrl.includes('?') ? '&' : '?';
                finalUrl = `${finalUrl}${separator}type=crawler_access`;
            }

            window.location.href = finalUrl;

        } catch (error) {
            console.error('Search execution failed:', error);
        }
    }, [
        isFromPaidJob,
        searchedKeyword,
        searchedLocation,
        narrowSearchParamsViewModel
    ]);

    return { executeSearch };
};

export default useSearchExecutor;
